import { ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { NgbModal, NgbModalRef, NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TicketHubService } from 'src/app/core/services/utelize/system/support/ticket-hub/ticket-hub.service';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { TicketComment } from 'src/app/core/models/system/support/ticket-hub/ticket-comment';
import { Ticket } from 'src/app/core/models/system/support/ticket-hub/ticket';
import { FormControl } from '@angular/forms';


@Component({
  selector: 'app-add-ticket-note-modal-form',
  templateUrl: './add-ticket-note-modal-form.component.html',
  styleUrls: ['./add-ticket-note-modal-form.component.scss']
})
export class AddTicketNoteModalFormComponent implements AfterViewInit, OnInit {
  @Input() embeddedFormMode                  : boolean | undefined;

  @Output() ticketNoteFormHasBeenSaved       : EventEmitter<void> = new EventEmitter<void>();  
  @Output() ticketNoteFormCancelled          : EventEmitter<void> = new EventEmitter<void>();

  @ViewChild('addTicketNoteModalForm',   { static: false }) addNoteModalForm!  : TemplateRef<void>;
  @ViewChild('completedModalForm',       { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('details',                  { static: false }) details!           : ElementRef;
  @ViewChild('ArrowNgbNav',              { static: false }) arrowNav!          : NgbNav;
  
  get modalBackGround    () { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                              return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
  get showTooltips      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTooltips,                 false); }
  
  private curUser             : SystemUserDTO;
  private ticketFormSubmitted : boolean = false;
  private ticketModalFormRef! : NgbModalRef;

  public addNoteButtonEnabled  : boolean = false;
  public addReplyButtonEnabled : boolean = false;
  public isSubmitting          : boolean = false;
  public currentDetails        : string = "";
  public currentHighPriority   : boolean = false;
  public error                 : string = "No notes found.";
  public formTitle             : string = 'View Ticket';
  public loadingNoteInfo       : boolean = false;
  public newComment            : FormControl = new FormControl();
  public newReply              : FormControl = new FormControl();
  public originalDetails       : string = "";
  public originalHighPriority  : boolean = false;
  public showAddNoteInfo       : boolean = false;
  public showAddReplyInfo      : boolean = false;
  public ticket?               : Ticket;
  public ticketNotes           : TicketComment[] = [];
  public updateButtonEnabled   : boolean = false;

  constructor(
    private authenticationService     : AuthenticationService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService,
    private ticketHubService          : TicketHubService,
    private modalService              : NgbModal
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {            
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy() {
    this.closeForm();
  }

  public closeForm(): void {
    try {
      this.ticketNoteFormCancelled.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.ticketFormSubmitted = false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(ticket: Ticket): void {
    try {
      this.formTitle            = 'View Ticket - ' + ticket.id;
      this.ticket               = ticket;
      this.currentDetails       = ticket.details;
      this.currentHighPriority  = ticket.highPriority;
      this.originalDetails      = ticket.details;
      this.originalHighPriority = ticket.highPriority;
      this.openModal();
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.ticketModalFormRef=this.modalService.open(this.addNoteModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
      this.getTicketComments();
      this.newComment.valueChanges.subscribe(changedValues => this.addNoteButtonEnabled  = this.newComment.value?.toString().trim() !== '');
      this.newReply.valueChanges.subscribe(changedValues  => this.addReplyButtonEnabled = this.newReply.value?.toString().trim()   !== '');
    }
    catch(e) {
      this.ticketNoteFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private getTicketComments() {
    try {
      this.ticketNotes    = [];
      this.loadingNoteInfo=true;
      this.ticketHubService.getTicketComment(this.ticket!.id, this.ticket!.company_id)
            .subscribe({
              next: data => {
                this.ticketNotes = data;
                this.loadingNoteInfo=false;
              },
              error: error => {
                this.loadingNoteInfo=false;
                this.exceptionsService.handleException(new Error(error));
              }
            });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onDetailsChange(newValue : string) {
    this.currentDetails = newValue;
    this.ticket!.update_description = this.currentDetails != this.originalDetails;
    this.setUpdateButtonEnabled();
  }

  public onHighPriorityCheckboxChange(event: Event) {
    try {
      const isChecked = (event.target as HTMLInputElement).checked;
      this.currentHighPriority = isChecked;
      this.ticket!.update_highPriority = this.currentHighPriority != this.originalHighPriority;
      this.setUpdateButtonEnabled();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ticketFormSubmit() {
    try {
      this.ticketFormSubmitted=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ticketFormCancel() {
    try {
      this.ticketNoteFormCancelled.emit();
      this.ticketModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalHasBeenClosed() {

  }

  public convertNewlinesToBreaks(text: string): string {
    return text ? text.replace(/\n/g, '<br>') : '';
  }

  public updateTicket() {
    try {
      if (!this.ticketFormSubmitted) {
        this.ticketFormSubmitted  = true;
        this.ticket!.highPriority = this.currentHighPriority;
        this.ticket!.details      = this.currentDetails;
        this.ticketHubService.put(this.ticket!)
         .subscribe({
                 next: data => {
                   this.ticketFormSubmitted         = false;
                   this.originalDetails             = this.currentDetails;
                   this.originalHighPriority        = this.currentHighPriority;
                   this.ticket!.update_description  = false;
                   this.ticket!.update_highPriority = false;
                   this.setUpdateButtonEnabled();
                   this.completedModalForm.openForm("Congratulations", "Ticket has been updated.");
                   this.ticketNoteFormHasBeenSaved.emit();
                 }
               });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setUpdateButtonEnabled() {
    this.updateButtonEnabled = this.currentHighPriority != this.originalHighPriority || this.currentDetails != this.originalDetails;
  }

  //#region Notes
  public addNote(): void {
    try {
      this.ticketFormSubmitted = true;
      this.isSubmitting        = true;
      this.ticketHubService.addComent({
        IssueKey   : this.ticket?.id.toString(),
        CommentBody: this.newComment.value.toString().trim()
      })
      .subscribe({
        next: data => {
          this.isSubmitting        = false;
          this.ticketFormSubmitted = false;
          this.completedModalForm.openForm("Congratulations", "Note has been added");
          this.showAddNoteInfo = false;
          this.ticketNoteFormHasBeenSaved.emit();
          this.newComment.setValue("");
          this.getTicketComments();
        },
        error: error => { this.isSubmitting = false; this.ticketFormSubmitted = false; this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.isSubmitting = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public addReply(): void {
    try {
      this.ticketFormSubmitted = true;
      this.isSubmitting        = true;
      this.ticketHubService.addReply({
        IssueKey   : this.ticket?.id.toString(),
        CommentBody: this.newReply.value.toString().trim()
      })
      .subscribe({
        next: data => {
          this.isSubmitting        = false;
          this.ticketFormSubmitted = false;
          this.completedModalForm.openForm("Congratulations", "Reply has been sent");
          this.showAddReplyInfo = false;
          this.ticketNoteFormHasBeenSaved.emit();
          this.newReply.setValue("");
          this.getTicketComments();
        },
        error: error => { this.isSubmitting = false; this.ticketFormSubmitted = false; this.exceptionsService.handleException(new Error(error)); }
      });
    }
    catch(e) {
      this.isSubmitting = false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public closeAddNote(): void {
    this.showAddNoteInfo = false;
  }

  public closeAddReply(): void {
    this.showAddReplyInfo = false;
  }

  public showAddNote(): void {
    this.showAddNoteInfo  = true;
    this.showAddReplyInfo = false;
  }

  public showAddReply(): void {
    this.showAddReplyInfo = true;
    this.showAddNoteInfo  = false;
  }
  //#end region

}
